export const NONE = "none";
export const COMPRESSION_PREFIX = "__LZ__";
export const COMPRESSION_PREFIX_URI = "__LZURI__";
export const DEFAULT_LANGUAGE = "it";
export const WARNING_VISIBILITY = 30; //Percentage of missing point to trigger visibility warning
export const FILTER_VISIBILITY = 1; //Seconds minimum number to be considered a proper visibility missing
export const IMPERSONATION = false;
// export const INDEX = true;
